import sliceCreator from '../../index.jsx';
import {CALCULATE_SALES_TARGET} from '../../../constants/index.jsx';
const _createCalculateSalesTargetAction = sliceCreator('CALCULATE_SALES_TARGET', CALCULATE_SALES_TARGET, 'post');

const { asyncAction: calculateSalesTargetAction, reducer, clearData: clearCalculateSalesTargetAction } = _createCalculateSalesTargetAction;

export default reducer;

export {
    calculateSalesTargetAction,
    clearCalculateSalesTargetAction
}